"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormatMessage = FormatMessage;
var react_1 = require("react");
var renderMessage_1 = require("./renderMessage");
var transformValues_1 = require("./transformValues");
function FormatMessage(_a) {
    var getMessage = _a.getMessage, id = _a.id, values = _a.values;
    var scalarValues = (0, transformValues_1.transformValues)(values);
    var message = getMessage(id, scalarValues);
    var children = (0, renderMessage_1.renderMessage)(message, values);
    return (0, react_1.createElement)(react_1.Fragment, undefined, children);
}
//# sourceMappingURL=FormatMessage.js.map